import { z } from "zod";
// Re-export validation schemas from the validation package
export { RegisterSchema, VerifyOTPSchema } from "@project-mgmt/validation";
// Additional client-side validation schemas
export const LoginFormSchema = z.object({
    phoneNumber: z
        .string()
        .min(10, "Phone number must be at least 10 digits")
        .max(15, "Phone number must be at most 15 digits")
        .regex(/^\+?[\d\s\-\(\)]+$/, "Invalid phone number format"),
});
export const OTPFormSchema = z.object({
    code: z
        .string()
        .length(6, "OTP must be exactly 6 digits")
        .regex(/^\d{6}$/, "OTP must contain only numbers"),
});
